import { ElementRef, inject, Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ProductListComponentService } from '@spartacus/storefront'
import { BehaviorSubject } from 'rxjs'
import { ICustomProduct } from '../../../models/ICustomProduct'

@Injectable({ providedIn: 'root' })
export class CompareProductsService extends ProductListComponentService {
  private compareContainer: ElementRef
  private compareProductsList: BehaviorSubject<Array<ICustomProduct>> = new BehaviorSubject<Array<ICustomProduct>>([])
  private snackBar = inject(MatSnackBar)

  public setCompareContainer(compareContainer: ElementRef) {
    this.compareContainer = compareContainer
  }

  public getCompareProductsList(): BehaviorSubject<Array<ICustomProduct>> {
    return this.compareProductsList
  }

  public initializeCompareService(): void {
    this.compareProductsList = new BehaviorSubject<Array<ICustomProduct>>([])
  }

  public addProductToCompare(productToCompare: ICustomProduct) {
    const currentProductList = this.compareProductsList.getValue()
    currentProductList.push(productToCompare)
    this.compareProductsList.next(currentProductList)

    this.openSnackBar(productToCompare.name)
  }

  public removeProductFromCompare(productToCompare: ICustomProduct) {
    const currentProductsList = this.compareProductsList.value
    const newProductsList = currentProductsList.filter((product) => product !== productToCompare)
    this.compareProductsList.next(newProductsList)
  }

  private openSnackBar(productName: string): void {
    const message: string = productName + ' added to compare list'
    const actionMessage: string = 'Compare ' + this.compareProductsList.getValue().length

    this.snackBar.open(message, actionMessage, {
      duration: 2500,
      panelClass: ['snackbar']
    })

    this.snackBar._openedSnackBarRef.onAction().subscribe(() => {
      this.compareContainer.nativeElement.scrollIntoView({ behavior: 'smooth' })
    })
  }
}
